var _defs, _rect, _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValues(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 720,
    height: 520,
    viewBox: "0 0 720 520",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "rg",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(360 260) rotate(90) scale(260)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFD278",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7AB16",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 720,
    height: 520,
    rx: 48,
    fill: "#F7F9FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 360,
    cy: 260,
    r: 220,
    fill: "url(#rg)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 480,
    height: 280,
    rx: 32,
    fill: "#FFFFFF",
    stroke: "#E1E9FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 28,
    fill: "#1E4BBA",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 70,
    width: 240,
    height: 12,
    rx: 6,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 94,
    width: 180,
    height: 10,
    rx: 5,
    fill: "#F1F4FF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 170,
    r: 28,
    fill: "#1E64DA",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 160,
    width: 220,
    height: 12,
    rx: 6,
    fill: "#E8EEFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 184,
    width: 200,
    height: 10,
    rx: 5,
    fill: "#F1F4FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValues);
export default __webpack_public_path__ + "static/media/values.ab044f97087b14238af6c2e29ec1e26f.svg";
export { ForwardRef as ReactComponent };